import React from 'react';
import LOGO from '../../assets/York-logo-fundobranco.jpg'
import "./styles.css"
import { useNavigate } from 'react-router-dom';

const menuItems = [
  {
    label: 'Dashboard',
    icon: 'fas fa-tachometer-alt',
    path: 'nps/dashboard',
  },
  {
    label: 'Avaliações NPS',
    icon: 'fas fa-chart-bar',
    path: 'nps/consulta',
  },
  {
    label: 'Pedidos',
    icon: 'fas fa-box-open',
    path: 'nps/pedidos',
  },
  {
    label: 'Clientes',
    icon: 'fas fa-users',
    path: 'nps/clientes',
  },
  {
    label: 'Motoristas',
    icon: 'fas fa-id-card',
    path: 'nps/motoristas',
  },
  {
    label: 'Ajudantes',
    icon: 'fas fa-user-plus',
    path: 'nps/ajudantes-motoristas',
  },


];

function Sidebar({ open, setOpen }) {
  const navigate = useNavigate();

  const goTo = (id) => {
    navigate(`/${id}`)
    // window.location.href = `/${id}`;
  };

  return (
    <div className="flex zoom8 h-full overflow-auto">
      <div id="sidebarOverlay" className="sidebar-overlay mt-5" />

      <div
        id="sidebar"
        className={`sidebar w-64 bg-white shadow-md fixed md:relative h-full z-20 ${open ? 'open' : ''}`}
      >
        <div className="p-4 border-b border-gray-200 flex items-center">
          <img
            src={LOGO}
            alt="Logo"
            className="w-12 h-12 rounded-full bg-primary flex items-center justify-center text-white font-bold"
          />
          <h1 className="ml-3 font-bold text-lg">NPS de Entrega</h1>
          <button
            id="closeSidebar"
            className="ml-auto md:hidden text-gray-500"
            onClick={() => setOpen(false)}
          >
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="p-4">
          <nav>
            <ul>
              {menuItems.map((item, index) => (
                <li key={index}>
                  <a
                    onClick={() => goTo(item.path)}
                    className={`sidebar-item 
                              ${window.location.pathname.includes(item.path) ? 'active' : ''}
                              flex items-center cursor-pointer p-3 rounded-lg mt-1 
                      `}
                  >
                    <i className={`${item.icon} w-5 ${item.active ? 'text-primary' : 'text-gray-500'}`} />
                    <span className="ml-3">{item.label}</span>
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className=" bottom-0 left-0 right-0 p-4 border-t border-gray-200">
          <a
            href="/"
            className="flex items-center p-3 text-gray-700 rounded-lg hover:bg-gray-100"
          >
            <i className="fas fa-sign-out-alt w-5 text-gray-500"></i>
            <span className="ml-3">Voltar para Helpdesk</span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
